import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy WordPress URL -> current canonical page
export const Route = createFileRoute("/ada-compliance-for-small-businesses-the-complete-guide-for-2025")({
  beforeLoad: () => {
    throw redirect({ href: "/articles/ada-compliance-for-small-businesses-2025", statusCode: 301 });
  },
});
